import React, { useState } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { FrontTabletButton } from '@/components/molecules/front-tablet/button'
import { ButtonType } from '@/components/atoms/button'

const iconHotelNotice = require('@/static/images/icon_hotel_notice.svg')

type Props = {
  messages: string[] | undefined
}

export const HotelNoticePopup: React.FC<Props> = ({ messages }) => {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState(!!messages)

  const handleConfirm = () => {
    setIsVisible(false)
  }

  if (!isVisible || !messages) {
    return <></>
  }
  return (
    <div css={overlayStyle}>
      <div css={cardStyle}>
        <div css={headerStyle}>
          <img alt="" css={headerIconStyle} src={iconHotelNotice} />
          <p css={headerTitleStyle}>{t('HotelNoticePopup.Title')}</p>
        </div>
        <div css={bodyStyle}>
          {messages.map((message, index) => (
            <div key={index} css={messageBoxStyle}>
              <p css={messageTextStyle}>{message}</p>
            </div>
          ))}
          <FrontTabletButton
            buttonType={ButtonType.Secondary}
            width={227}
            onClick={handleConfirm}
            customCss={{ fontSize: 26, letterSpacing: '1.3px' }}
          >
            {t('HotelNoticePopup.Confirm')}
          </FrontTabletButton>
        </div>
      </div>
    </div>
  )
}

const overlayStyle = css({
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 103,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const cardStyle = css({
  backgroundColor: '#fff',
  borderRadius: 10,
  width: 826,
  maxWidth: '90%',
  overflow: 'hidden',
})

const headerStyle = css({
  backgroundColor: '#f2a40b',
  height: 91,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 16,
})

const headerIconStyle = css({
  width: 62,
  height: 62,
})

const headerTitleStyle = css({
  color: '#fff',
  fontSize: 26,
  fontWeight: 'bold',
  letterSpacing: '1.3px',
})

const bodyStyle = css({
  padding: '40px 60px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 40,
})

const messageBoxStyle = css({
  backgroundColor: '#f2f2f2',
  borderRadius: 10,
  padding: 40,
  width: '100%',
})

const messageTextStyle = css({
  fontSize: 24,
  fontWeight: 500,
  color: '#272727',
  letterSpacing: '1.2px',
  lineHeight: 1.6,
  whiteSpace: 'pre-wrap',
  margin: 0,
})
